import { useCallback, useContext } from "react";

import { LoanSimulation } from "../../interfaces/LoanSimulation";

import { LoanContext } from "./loan-context";

export const useLoanSimulation = () => {
  const { loanSimulation, setLoanSimulation } = useContext(LoanContext);

  const createLoanSimulation = useCallback(
    (newLoan: LoanSimulation | null): void => {
      setLoanSimulation(newLoan);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loanSimulation]
  );

  const deleteLoanSimulation = useCallback((): void => {
    setLoanSimulation(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loanSimulation]);

  return {
    loanSimulation,
    createLoanSimulation,
    deleteLoanSimulation,
  };
};
